import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../usecases/object";

export default class RecordCompanyFormPresenter extends BaseFormPresenter {
  async submit() {
    // ADD ADMIN AS DEFAULT LOCKED TO USER
    const [admin] = await findObjectUseCase().execute("users", {
      where: { username: "admin" },
    });

    this.change = {
      ...this.change,
    };

    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      await this.view.showConfirmationDialog();
      await this.save(admin);
      this.view.submissionSuccess();
      toast.success("Successfully saved!", { position: "top-right" });
      this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }

  async save(admin) {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      const record = await this.upsertUseCase.execute(collection, this.change);

      // ADD ACCESS HISTORY
      const newHistory = {
        record,
        accessor: admin,
      };

      await this.upsertUseCase.execute("access_history", newHistory);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }
}
